import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  prefix:string = 'hlx';
  delimiter:string = '|';
  cookieExpireDays:number = 7

  constructor() {
    //create session id if not present
    if (!this.loadSessionStorage("sessionId")) {
      this.saveSessionStorage('sessionId', uuidv4());
    }
  }

  saveLocalStorage(name:string, value:any) {
    localStorage.setItem(`${this.prefix}${this.delimiter}${name}`, JSON.stringify(value));
  }

  saveSessionStorage(name:string, value:any) {
    sessionStorage.setItem(`${this.prefix}${this.delimiter}${name}`, JSON.stringify(value));
  }

  loadLocalStorage(name:string):any {
    let item = localStorage.getItem(`${this.prefix}${this.delimiter}${name}`);
    if (item) {
      item =  JSON.parse(item);
    }
    return item; 
  }

  loadSessionStorage(name:string):any {
    let item = sessionStorage.getItem(`${this.prefix}${this.delimiter}${name}`);
    if (item) {
      item =  JSON.parse(item);
    }
    return item;
  }

  removeLocalStorage(name:string) {
    localStorage.removeItem(`${this.prefix}${this.delimiter}${name}`);
  }

  removeSessionStorage(name:string) {
    sessionStorage.removeItem(`${this.prefix}${this.delimiter}${name}`);
  }

  clearAllStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }

  saveCookie(name: string, value: string, expiredays?: number) {
    if (!expiredays) {
      expiredays = this.cookieExpireDays;
    }
    const d = new Date();
    d.setTime(d.getTime() + (expiredays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax;" ;
  }

  loadCookie(name:string) {
    name = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  getSessionId() {
    return this.loadSessionStorage('sessionId');
  }
}
